import React from 'react';

const SOMaterialReturnEntry = ({ soMaterial, inwardData }) => {
    console.log(soMaterial);
    return (
        <div>
            {soMaterial.length > 0 &&
                <div style={{ marginLeft: '5%' }}>
                    <table>
                        <thead>
                            <tr>
                                <th>Material Name</th>
                                <th>Size</th>
                                {soMaterial?.[0].info?.row.map(i => (
                                    <th key={i.size}>{i.size}</th>
                                ))}
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {soMaterial.map((item, index) => {
                                const rows = item?.info.row?.map((it, vidx) => {
                                    const qty = parseFloat(inwardData[vidx] || 0);

                                    {/* const qty = 0; */ }
                                    const matgqty = parseFloat(it.matgqty);
                                    const matsize = parseFloat(it.matsize);

                                    let issqty = 0;
                                    let issmtr = 0;
                                    let issInch = 0;
                                    let issmqty = 0;

                                    switch (item.mtype) {
                                        case "Pcs":
                                            issqty = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                            issmqty = parseFloat(matgqty) * parseFloat(matsize) * qty;

                                            break;

                                            {/* case "Mtr":
                                            issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                            issInch = (issmtr * 39.3701).toFixed(2);
                                            issmqty = parseFloat(matgqty) * qty; */}

                                            break;
                                        case "Mtr":
                                        case "Inch":
                                            {/* issInch = matgqty * qty; */ }
                                            issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                            issmtr = (issInch / 39.3701).toFixed(2);
                                            issmqty = parseFloat(matgqty) * qty;

                                            break;

                                        default:
                                            break;
                                    }

                                    return {
                                        ...it,
                                        issqty,
                                        issmtr,
                                        issInch,
                                        issmqty
                                    };
                                });
                                const mtype = item.mtype;

                                {/* const totitemqty = qtyArr.reduce((acc, sum) => acc + parseFloat(sum || 0), 0); */ }
                                const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                                const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                                const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                                const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);
                                return (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td rowSpan={6}>
                                                {item.materialNm}
                                                <br />
                                                <small>({item.mtype})</small>

                                            </td>
                                            <td>Material Length</td>
                                            {rows.map(i => (
                                                <td key={i.matsize}>{i.matsize}</td>
                                            ))}
                                            <td></td>
                                        </tr>

                                        <tr>
                                            <td>Per Size M. Qty.</td>
                                            {rows.map(i => (
                                                <td key={i.matsize}>{i.matgqty}</td>
                                            ))}
                                            <td></td>
                                        </tr>
                                        {/* style={{ fontWeight: 800, background: '#fccfa1' }} */}
                                        <tr>
                                            <td>Qty.</td>
                                            {inwardData.map((q, i) => (
                                                <td key={i}>{q}</td>
                                            ))}
                                            {/* <td><b>{totitemqty}</b></td> */}
                                            <td></td>
                                        </tr>

                                        <tr style={{ fontWeight: 800, background: '#fdd4d4' }}>
                                            <td>Mtr.</td>
                                            {rows.map(i => (
                                                <td key={i.matsize}>{i.issmtr}</td>
                                            ))}
                                            <td><b>{totissmtr.toFixed(2)}</b></td>
                                        </tr>

                                        <tr style={{ fontWeight: 800, background: '#85e07c' }}>
                                            <td>Inch.</td>
                                            {rows.map(i => (
                                                <td key={i.matsize}>{i.issInch}</td>
                                            ))}
                                            <td><b>{totissInch.toFixed(2)}</b></td>
                                        </tr>

                                        <tr style={{ fontWeight: 800, background: '#b4b4f7' }}>
                                            <td>Total Qty.</td>
                                            {rows.map(i => (
                                                <td key={i.matsize}>{i.issmqty}</td>
                                            ))}
                                            <td><b>{totissmqty.toFixed(2)}</b></td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>

                    </table>


                    <table>
                        <thead>
                            <th>Sr.No.</th>
                            <th>Barcode</th>
                            <th>Material</th>
                            <th>M type</th>
                            <th>Issue P Qty.</th>
                            <th>Return P Qty.</th>
                            <th>Bal P Qty.</th>
                            <th>Issue Mtr</th>
                            <th>Return Mtr</th>
                            <th>Bal Mtr</th>
                            <th>Issue Inch</th>
                            <th>Return Inch</th>
                            <th>Bal Inch</th>
                            <th>Issue Totqty</th>
                            <th>Return Totqty</th>
                            <th>Bal Totqty</th>
                        </thead>
                        <tbody>
                            {soMaterial?.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {index + 1}</td>
                                    <td>{item.barcode}</td>
                                    <td>{item.materialNm}</td>
                                    <td>{item.mtype}</td>
                                    <td>{item.outqty}</td>
                                    <td>{item.reoutqty}</td>
                                    <td>{(Number(item.outqty) - Number(item.reoutqty)).toFixed(2)}</td>
                                    <td>{item.outMtr}</td>
                                    <td>{item.reoutmtr}</td>
                                    <td>{(Number(item.outMtr) - Number(item.reoutmtr)).toFixed(2)}</td>
                                    <td>{item.outInch}</td>
                                    <td>{item.reoutinch}</td>
                                    <td>{(Number(item.outInch) - Number(item.reoutinch)).toFixed(2)}</td>
                                    <td>{item.outBoxQty}</td>
                                    <td>{item.reoutTotqty}</td>
                                    <td>{(Number(item.outBoxQty) - Number(item.reoutTotqty)).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default SOMaterialReturnEntry;
